import { render } from "./WCItemModifierAnswers.vue?vue&type=template&id=646ede5c&scoped=true"
import script from "./WCItemModifierAnswers.vue?vue&type=script&lang=js"
export * from "./WCItemModifierAnswers.vue?vue&type=script&lang=js"

import "./WCItemModifierAnswers.vue?vue&type=style&index=0&id=646ede5c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646ede5c"]])

export default __exports__